import { Info } from "lucide-react";
import { ServiceCategoryName } from "@/lib/services";

export const INSURANCE_CATEGORIES = new Set<ServiceCategoryName>([
  "Einkommensversicherung",
  "Sachversicherungen",
  "Gesundheitsvorsorge",
  "Gewerbeversicherung",
]);

export interface InsuranceDisclaimerProps {
  category: ServiceCategoryName;
}

export default function InsuranceDisclaimer({ category }: InsuranceDisclaimerProps) {
  if (!INSURANCE_CATEGORIES.has(category)) return null;

  return (
    <div className="reveal rounded-2xl border border-accent/30 bg-accent/10 p-6 md:p-8 shadow-card">
      <div className="flex items-start gap-4">
        <div className="shrink-0 w-10 h-10 rounded-xl bg-accent/20 text-accent flex items-center justify-center">
          <Info className="w-5 h-5" />
        </div>
        <div>
          <h3 className="font-display text-lg font-bold text-primary">Hinweis</h3>
          <p className="mt-1.5 text-muted-foreground leading-relaxed">
            Verfügbarkeit und genaue Bedingungen der dargestellten Leistungen können je nach Versicherer variieren. Die konkreten Vertragsdetails ergeben sich aus den jeweiligen Versicherungsbedingungen des gewählten Anbieters.
          </p>
        </div>
      </div>
    </div>
  );
}
